import { render, staticRenderFns } from "./QuestionCreate.vue?vue&type=template&id=15832ea1&"
import script from "./QuestionCreate.vue?vue&type=script&lang=js&"
export * from "./QuestionCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports